export type Locale = 'zh' | 'en';

const ENGLISH: { [key: string]: string } = {
    等待输入: 'Waiting for input',
    选择麦克风或音频文件开始: 'Choose the microphone or an audio file to begin',
    实时分析中: 'Live analysis',
    分析已停止: 'Analysis stopped',
    '正在准备音频…': 'Preparing audio…',
    个文件: 'files',
    '正在建立分析缓存…': 'Building analysis cache…',
    无法读取音频文件: 'Unable to read the audio file',
    '正在请求麦克风权限…': 'Requesting microphone permission…',
    麦克风不可用: 'Microphone unavailable',
    无法打开麦克风: 'Unable to open the microphone',
    '正在解码音频…': 'Decoding audio…',
    无法读取此音频: 'Unable to read this audio',
    点击麦克风开始新的录音分段: 'Click Microphone to start a new recording',
    '已定位，按绿色播放按钮开始': 'Positioned · Press the green play button to begin',
    分析缓存已就绪: 'Analysis cache ready',
    '播放列表已清空，可开始新的会话': 'Playlist cleared · Ready for a new session',
    '音频已移除，可开始新的会话': 'Audio removed · Ready for a new session',
    '正在分析整段宽带语谱…': 'Analyzing the full broadband spectrogram…',
    '正在分析整段窄带语谱…': 'Analyzing the full narrowband spectrogram…',
    '正在分析自定义语谱…': 'Analyzing the custom spectrogram…',
    '正在渲染当前视野…': 'Rendering the current view…',
    无法分析此音频: 'Unable to analyze this audio',
    '整段分析完成，可自由拖动播放': 'Full analysis complete · Drag or play freely',
    '录音较长，已暂停语谱图渲染，请先放大视图':
        'This recording is long, so spectrogram rendering is paused. Zoom in to render a view',
    '当前视野已渲染，可继续放大查看细节': 'Current view rendered · Zoom in further for more detail',
    '语谱图已就绪，声学轨迹后台加载中…':
        'Spectrogram ready · Loading acoustic tracks in the background…',
    '部分声学轨迹加载失败，正在自动重试…':
        'Some acoustic tracks failed to load · Retrying automatically…',
    后台分析: 'Background analysis',
    分析任务已完成: 'Analysis tasks complete',
    部分任务未完成: 'Some tasks did not complete',
    正在准备分析结果: 'Preparing analysis results',
    加速引擎: 'Acceleration engine',
    正在准备: 'Preparing',
    已就绪: 'Ready',
    已切换兼容模式: 'Compatibility mode enabled',
    '加速引擎加载失败，已切换兼容模式':
        'Acceleration engine failed to load · Compatibility mode enabled',
    语谱渲染: 'Spectrogram rendering',
    等待语谱: 'Waiting for spectrogram',
    正在渲染: 'Rendering',
    基频与音强: 'Pitch and intensity',
    共振峰分析: 'Formant analysis',
    等待分析: 'Waiting for analysis',
    正在分析: 'Analyzing',
    正在重试: 'Retrying',
    完成: 'Complete',
    失败: 'Failed',
    播放完成: 'Playback complete',
    选区播放完成: 'Selection playback complete',
    '播放中 · 分析图保持完整': 'Playing · Full analysis remains visible',
    '已暂停，可拖动定位': 'Paused · Drag to seek',
    '分析已停止，可滚轮回看': 'Analysis stopped · Scroll to review',
    会话时间: 'Session time',
    导入音频: 'Import audio',
    播放列表: 'Playlist',
    停止: 'Stop',
    麦克风: 'Microphone',
    显示设置: 'Display settings',
    清空播放列表: 'Clear playlist',
    清空: 'Clear',
    展开播放列表: 'Expand playlist',
    收起播放列表: 'Collapse playlist',
    展开列表: 'Expand list',
    收起列表: 'Collapse list',
    关闭播放列表: 'Close playlist',
    '始终置顶 · 结束后生成录音分段': 'Always pinned · A recording is added when finished',
    '导入音频或录制一段声音后，会保留在这里。': 'Imported audio and recordings will stay here.',
    重命名: 'Rename',
    '正在分析…': 'Analyzing…',
    分析失败: 'Analysis failed',
    双击重命名: 'Double-click to rename',
    保存: 'Save',
    保存WAV: 'Save WAV',
    从播放列表移除: 'Remove from playlist',
    移除: 'Remove',
    拖动调整顺序: 'Drag to reorder',
    语谱类型: 'Spectrogram type',
    宽带: 'Broadband',
    窄带: 'Narrowband',
    自定义: 'Custom',
    可调窗口: 'Adjustable window',
    共振峰: 'Formants',
    谐波: 'Harmonics',
    基频: 'Pitch',
    窄带基频与频率轴对齐: 'Align narrowband pitch to frequency axis',
    '让基频曲线与语谱频率使用同一纵坐标，以检查第一谐波重叠':
        'Use the spectrogram frequency axis for pitch to check overlap with the first harmonic',
    音强: 'Intensity',
    波形: 'Waveform',
    图层显示: 'Plot visibility',
    显示或隐藏波形: 'Show or hide waveform',
    显示或隐藏语谱图: 'Show or hide spectrogram',
    调整波形和语谱图高度: 'Resize waveform and spectrogram',
    波形尺度: 'Waveform scale',
    线性振幅: 'Linear amplitude',
    对数增强: 'Log enhancement',
    左轴参考单位: 'Left-axis reference unit',
    不显示: 'Hidden',
    振幅单位基准: 'Amplitude unit reference',
    '原始 PCM 电平基准': 'Raw PCM level reference',
    整段录音峰值基准: 'Whole-recording peak reference',
    'Live 录音固定使用原始 PCM 电平基准，不能切换':
        'Live recording uses the raw PCM level reference and cannot be changed',
    '整段录音绝对峰值定义为振幅 1.0，右轴仍使用 ±1.0 振幅单位':
        'Define the whole recording’s absolute peak as amplitude 1.0; the right axis remains in ±1.0 amplitude units',
    '原始 PCM ±1.0 定义为振幅 ±1.0，保留文件实际数字电平':
        'Define raw PCM ±1.0 as amplitude ±1.0, preserving the file’s actual digital level',
    '固定数字满刻度，保留真实波形比例':
        'Fixed digital full scale that preserves the true waveform proportions',
    '线性绘制波形，以 dBFS 标注振幅位置': 'Draw linearly and label amplitude positions in dBFS',
    '放大弱信号，仅改变视觉显示': 'Enhance weak signals for display only',
    '调整波形可视高度，不改变录音内容':
        'Adjust the visible waveform height without changing the recording',
    自动适配当前视图: 'Auto-fit current view',
    '根据可见区域峰值调整，不用于比较真实电平':
        'Adjust from the visible peak; not suitable for true level comparisons',
    适配当前视图: 'Fit current view',
    电平显示: 'Level display',
    峰值保持: 'Peak hold',
    削波提示: 'Clipping warning',
    语谱主题: 'Spectrogram theme',
    波形主题: 'Waveform theme',
    波形垂直缩放: 'Waveform vertical scale',
    波形粗细: 'Waveform line width',
    显示零线: 'Show zero line',
    在波形中心显示振幅基准线: 'Show an amplitude reference at the waveform center',
    显示脉冲: 'Show pulses',
    在有声区显示周期同步的声门脉冲时刻:
        'Show pitch-synchronous glottal pulse times in voiced regions',
    '波形主题仅改变纯色背景和波形颜色，不影响语谱主题或整体界面模式。':
        'Waveform themes only change the solid background and waveform colors, without affecting the spectrogram theme or interface mode.',
    切换到浅色模式: 'Switch to light mode',
    切换到深色模式: 'Switch to dark mode',
    性能: 'Performance',
    暂停: 'Pause',
    播放: 'Play',
    缩小: 'Zoom out',
    放大: 'Zoom in',
    扩选: 'Expand',
    返回: 'Back',
    全部: 'All',
    先在语谱图中拖动选择一段音频: 'Drag on the spectrogram to select audio first',
    让选区扩展至铺满语谱图: 'Expand the selection to fill the spectrogram',
    返回扩选前的视图: 'Return to the view before expanding',
    '显示完整语谱图至 1×': 'Show the full spectrogram at 1×',
    导出图片: 'Export image',
    编辑: 'Edit audio',
    复制: 'Copy',
    剪切: 'Cut',
    粘贴: 'Paste',
    复制选中的音频片段: 'Copy the selected audio segment',
    剪切选中的音频片段: 'Cut the selected audio segment',
    粘贴到播放头后: 'Paste after the playhead',
    已复制选中的音频片段: 'Selected audio segment copied',
    已编辑: 'Edited',
    不能剪切全部音频: 'The entire audio cannot be cut',
    '正在重新分析编辑后的音频…': 'Reanalyzing the edited audio…',
    全屏: 'Fullscreen',
    基频Hz: 'Pitch Hz',
    播放位置: 'Playback position',
    放大后的语谱滚动位置: 'Zoomed spectrogram scroll position',
    放大后的图形滚动位置: 'Zoomed plot scroll position',
    拖动查看放大后未显示的音频: 'Drag to view audio outside the zoomed window',
    时间: 'Time',
    现在: 'Now',
    回看历史: 'Review history',
    频率: 'Frequency',
    展开声学概览: 'Expand acoustic overview',
    点击切换指标: 'Click to switch metric',
    实时读数: 'Live readings',
    时刻线位置读数: 'Readings at the playhead',
    '波形交互区：单击定位，单指拖动选择，双指拖动平移':
        'Waveform: tap to seek, drag with one finger to select, drag with two fingers to pan',
    '语谱图交互区：单击定位并显示坐标，单指拖动选择，双指拖动平移':
        'Spectrogram: tap to seek and inspect coordinates, drag with one finger to select, drag with two fingers to pan',
    声学概览: 'Acoustic overview',
    收起声学概览: 'Collapse acoustic overview',
    关闭声学概览: 'Close acoustic overview',
    缩成气泡: 'Collapse to bubble',
    基频F0: 'Pitch F0',
    'YIN / 自相关实时估计': 'Live YIN / autocorrelation estimate',
    '参考声压 20 μPa': 'Reference pressure 20 μPa',
    当前会话统计: 'Current session statistics',
    平均F0: 'Mean F0',
    F0范围: 'F0 range',
    有声比例: 'Voiced frames',
    平均音强: 'Mean intensity',
    '浏览器麦克风没有统一声压校准。当前按 Praat 公式并假定 1.0 样本单位 = 1 Pa；绝对 SPL 仅作参考。':
        'Browser microphones have no standard sound-pressure calibration. Praat’s formula is used with 1.0 sample unit = 1 Pa; absolute SPL is for reference only.',
    清空会话: 'Clear session',
    保存当前画面: 'Save current view',
    调整画面: 'Adjust display',
    关闭设置: 'Close settings',
    关闭分析提示: 'Dismiss analysis status',
    语谱图: 'Spectrogram',
    恢复本页默认参数: 'Restore defaults for this tab',
    渲染帧率: 'Render frame rate',
    无限制浏览器刷新率: 'Unlimited (browser refresh rate)',
    '较低帧率可显著降低实时 GPU 占用':
        'A lower frame rate can significantly reduce real-time GPU usage.',
    内部渲染分辨率: 'Internal render resolution',
    '遇到性能问题时可适当降低，数值越高画面越清晰':
        'Lower this when performance is limited; higher values produce a sharper image.',
    毛玻璃效果: 'Glass effect',
    关闭后可降低动态图层的合成开销:
        'Turning this off reduces the compositing cost of dynamic layers.',
    实时分析精度: 'Real-time analysis precision',
    精确每帧分析: 'Accurate · analyze every frame',
    均衡降低全部分析频率: 'Balanced · reduce all analysis cadence',
    流畅大幅降低分析频率: 'Smooth · greatly reduce analysis cadence',
    '只降低实时分析的时间采样密度，每个被分析帧仍使用完整算法；离线音频始终保持精确。':
        'Only the real-time sampling cadence is reduced. Every analyzed frame still uses the full algorithm; offline audio always stays accurate.',
    '快捷键：空格播放或暂停；左右方向键按当前画面 1% 移动，按住 Shift 时按 5% 移动；长按右键正放、长按左键倒放，Shift + 长按以 3× 试听，松开自动暂停。':
        'Shortcuts: Space plays or pauses; Left/Right moves by 1% of the visible view, or 5% with Shift. Hold Right to play forward or Left to play in reverse; add Shift for 3× and release to pause.',
    显示增益: 'Display gain',
    语谱窗口长度: 'Spectrogram window length',
    显示指针信息气泡: 'Show pointer info bubble',
    '在语谱图上跟随指针显示时间、频率与声学读数':
        'Show time, frequency, and acoustic readings beside the spectrogram pointer',
    选择自定义模式后可调节窗口长度: 'Select Custom mode to adjust the window length.',
    窗口形状: 'Window shape',
    层次对比: 'Layer contrast',
    显示频率上限: 'Display frequency ceiling',
    显示频率下限: 'Display frequency floor',
    频率刻度: 'Frequency scale',
    线性: 'Linear',
    对数: 'Logarithmic',
    颜色主题: 'Color theme',
    '专业语音建议：宽带使用 5 ms、频率上限 5000–5500 Hz。默认显示增益与层次对比已按语音共振峰优化；若录音噪声较大，可继续降低层次对比。':
        'Speech tip: use a 5 ms broadband window and a 5000–5500 Hz ceiling. The default gain and contrast are tuned for speech formants; lower contrast further for noisy recordings.',
    '专业语音建议：窄带使用 30 ms，适合分辨基频与谐波；需要观察共振峰运动时请切换宽带。':
        'Speech tip: use a 30 ms narrowband window to resolve pitch and harmonics. Switch to Broadband to inspect formant movement.',
    '自定义语音建议：较短窗口突出时间变化与共振峰，较长窗口突出基频与谐波；可从 15 ms 开始按目标调节。':
        'Custom speech tip: shorter windows emphasize timing and formants, while longer windows emphasize pitch and harmonics. Start at 15 ms and adjust for your goal.',
    F0检测算法: 'F0 detection algorithm',
    归一化自相关: 'Normalized autocorrelation',
    搜索与显示下限: 'Search and display floor',
    搜索与显示上限: 'Search and display ceiling',
    有声阈值: 'Voicing threshold',
    曲线粗细: 'Line width',
    LPC分析数量: 'LPC analysis count',
    画面显示数量: 'Displayed formants',
    条: 'formants',
    有效分析窗: 'Analysis window',
    预加重起点: 'Pre-emphasis from',
    绘制动态范围: 'Drawing dynamic range',
    点大小: 'Dot size',
    'Praat 建议：成人男性可从 5000 Hz 起，成人女性从 5500 Hz 起；即使只显示 F1–F3，也通常保留 5 条分析数量。':
        'Praat tip: start around 5000 Hz for adult men and 5500 Hz for adult women. Keep five analyzed formants even when displaying only F1–F3.',
    音强窗Pitchfloor: 'Intensity window pitch floor',
    显示下限: 'Display floor',
    显示上限: 'Display ceiling',
    设备校准偏移: 'Device calibration offset',
    波形内容基准补偿: 'Waveform content-reference compensation',
    '根据当前录音峰值自动计算，仅用于波形坐标换算':
        'Calculated automatically from the current recording peak; used only for waveform-axis conversion',
    '使用整段录音峰值基准时，波形坐标自动使用 20 log10（录音峰值）的内容基准补偿；使用原始 PCM 电平基准时补偿为 0 dB。音强曲线始终根据原始样本实际电平计算，不受波形显示基准影响。设备校准偏移应使用相同录音增益下的已知声压参考信号确定。':
        'With the whole-recording peak reference, the waveform axis automatically uses 20 log10(recording peak) as content-reference compensation; the raw PCM level reference uses 0 dB. The intensity contour is always calculated from the actual level of the original samples and is unaffected by the waveform display reference. Determine the device calibration offset from a known sound-pressure reference recorded at the same gain.',
    '未经声级计校准时只比较相对变化；校准偏移用于已知声压级的麦克风系统。':
        'Without a sound-level meter calibration, compare relative changes only. Use the offset for microphone systems with a known SPL.',
    '当前按 Praat 约定假定 1.0 样本单位 = 1 Pa。未经声级计校准时，绝对 dB SPL 仅作参考；校准偏移用于已知声压级的麦克风系统。':
        'Following the Praat convention, 1.0 sample unit is treated as 1 Pa. Without sound-level meter calibration, absolute dB SPL is only a reference; use the offset for systems with a known SPL.',
    宽带语谱: 'Broadband spectrogram',
    窄带语谱: 'Narrowband spectrogram',
    自定义语谱: 'Custom spectrogram',
    '5 ms 有效窗，约 260 Hz 带宽。时间分辨率高，适合观察共振峰运动。':
        'A 5 ms effective window with about 260 Hz bandwidth. High time resolution is ideal for tracking formant movement.',
    '30 ms 有效窗，约 43 Hz 带宽。频率分辨率高，适合比较 F0 与第一谐波。':
        'A 30 ms effective window with about 43 Hz bandwidth. High frequency resolution is ideal for comparing F0 with the first harmonic.',
    '自定义窗口长度可在 1–100 ms 之间调节，用于比较时间与频率分辨率。':
        'Adjust the custom window from 1–100 ms to compare time and frequency resolution.',
    切换到英文: 'Switch to English',
    切换到中文: 'Switch to Chinese',
    选择语言: 'Choose language',
    录音: 'Recording',
    'Spectro Pro · 实时声学显示器': 'Spectro Pro · Real-time acoustic visualizer',
    'Spectro Pro 是一个现代、实时、易用的浏览器声学可视化工具。':
        'Spectro Pro is a modern, real-time acoustic visualizer for the browser.',
    宽带与窄带语谱实时基频共振峰和音强曲线:
        'Broadband and narrowband spectrograms with live pitch, formants, and intensity.',
};

export const detectBrowserLocale = (): Locale => {
    if (typeof navigator === 'undefined') {
        return 'en';
    }
    const language = navigator.languages?.[0] || navigator.language;
    return /^zh(?:-|$)/i.test(language || '') ? 'zh' : 'en';
};

export const translate = (text: string, locale: Locale): string =>
    locale === 'zh' ? text : ENGLISH[text] || text;

let activeLocale = detectBrowserLocale();

export const getActiveLocale = (): Locale => activeLocale;

export const setActiveLocale = (locale: Locale) => {
    activeLocale = locale;
};

export const t = (text: string): string => translate(text, activeLocale);
